module.exports = __webpack_public_path__ + "img/logo.8298177c.png";